import template from './insuranceAppWorkbenchModal.html';
import controller from './insuranceAppWorkbenchModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    quoteId: '<',
    familyId: '<',
    modalInstance: '<',
  },
};
